import { Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { selectLicenseList } from "../Body/api/redux";
import DashboardPotentialCards from "./DashboardPotentialCards";

export default () => {
  const state = useSelector(selectLicenseList);
  return (
    <div className="col-12 col-md-6 d-flex flex-wrap my-2">
      {/* <h5 className="my-0 col-12 text-right ">پتانسیل های سرمایه گذاری</h5> */}
      {/* <Divider className="col-12" /> */}
      <div className="col-12 mb-auto">
        {" "}
        {state.potentials &&
          state.potentials.map((el) => {
            return <DashboardPotentialCards data={el} />;
          })}
      </div>
    </div>
  );
};
